export enum Weight {
  w700 = '700',
  w400 = '400'
}

export const WeightValues = Object.values(Weight)
export type WeightArray = typeof WeightValues
export type TypeWeight = WeightArray[number]
